export class Organisation {
    constructor(data) {
        this.featureFlags = [];
        Object.assign(this, data);
        if (!this.featureFlags) {
            this.featureFlags = [];
        }
    }
    hasFeatureFlag(flag) {
        console.log('Checking feature flag:', flag);
        console.log('Available flags:', this.featureFlags.map(f => f.name));
        console.log(this);
        return this.featureFlags.some(f => f.name === flag);
    }
}
